export const enum OEM {
    MSIL = "msil",
    SKODA = "skoda",
    MMC = "mmc",
    VW = "vw",
}
